import { render, staticRenderFns } from "./SelectTransactionType.vue?vue&type=template&id=288faadd"
import script from "./SelectTransactionType.vue?vue&type=script&lang=js"
export * from "./SelectTransactionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports